<template lang="html">
  <div>
    <div class="blocklist_header_top">
      <van-nav-bar
        :title="title"
        right-text="发帖"
        left-arrow
        fixed
        @click-left="onClickLeft"
        @click-right="onClickRight"/>

    </div>
    <div class="blocklist_content">
      <div v-show="sublist.length>0">
        <ul class="block_list">
          <li v-for="(i, val) in sublist" :key="val"  @click="toBlock(i.fid)">
            <div class="img_box">
              <img :src="i.iconimg" alt="">
            </div>
            <div class="block_item_right">
              <h2>{{i.name}}</h2>
              <p class="ellipsis">{{i.lastpost.subject}}</p>
              <span>主题：{{i.threads}}</span><em>贴数：{{i.posts}}</em>
            </div>
          </li>
        </ul>
      </div>
      <ul class="tab_right_list">
        <router-link tag="li" class="tab_right_item" v-for="(item, index) in blockList" :key="index" :to="`/article/${item.tid}`">
          <div class="item_left">
            <h2>{{item.subject}}</h2>
            <span>{{item.author}}</span>
            <em>{{item.dateline}}发布</em>
          </div>
          <div class="item_right">
            <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.authorid}&size=middle`" alt="">
          </div>
        </router-link>
      </ul>
      <span class="loadMore" @click="getBlockListLoadMoreData">{{loadMoreTxt}}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { NavBar } from 'vant'

Vue.use(NavBar)
export default {
  data() {
    return {
      blockList: [],
      listPage: 1,
      title:'论坛版块',
      sublist:[],
      loadMoreTxt: '点击加载更多'
    }
  },
  created() {
    this.getbBlockListData()
  },
  watch:{
    '$route' : 'getbBlockListData'
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      this.$router.push('/post/'+this.$route.params.fid);
    },
    // ----获取版块列表数据----
    getbBlockListData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&orderby=dateline&fid='+ this.$route.params.fid +'&page=' + this.listPage,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.blockList = res.data.list
            this.title=res.data.name
          }
          this.blockList = res.data.list
          this.sublist=res.data.sublist;
       
        }
      })
    },
    toBlock(fid){
      window.location.href='/dist/#/blocklist/'+fid;
      console.log(fid)
    },
    getBlockListLoadMoreData() {
      this.listPage = this.listPage + 1
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=forumdisplay&orderby=dateline&fid='+ this.$route.params.fid +'&page=' + this.listPage,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            for(let i in res.data.list){
              this.blockList.push(res.data.list[i])
            }
            
            
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.blocklist_content{
  margin-top: .46rem;
  .loadMore{
    display: block;
    width: 100%;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
  }
  .tab_right_list{
    padding: .1rem;
    background: #fff;
    .tab_right_item{
      display: flex;
      padding: .1rem 0;
      border-bottom: 1px solid #eaeaea;
      .item_left{
        flex: 1;
        h2{
          font-size: .14rem;
          color: #222;
          line-height: .2rem;
        }
        span{
          font-size: .12rem;
          color: #666;
          line-height: .3rem;
          margin-right: .1rem;
        }
        em{
          font-size: .12rem;
          color: #888;
          line-height: .3rem;
        }
      }
      .item_right{
        width: .6rem;
        height: .6rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.block_list{
  padding: 0 .1rem;
  background: #fff;
  border-top: 1px solid #EEE;
  margin-bottom: .1rem;
  li{
    width: 100%;
    height: 1rem;
    border-bottom: 1px solid #EEE;
    display: flex;
    .img_box{
      width: 1rem;
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: .7rem;
        height: .7rem;
        border-radius: 100%;
      }
    }
    .block_item_right{
      flex: 1;
      height: 100%;
      padding: 0 0 0 .1rem;
      h2{
        font-size: .16rem;
        line-height: .3rem;
        margin-top: .14rem;
      }
      p{
        font-size: .12rem;
        line-height: .24rem;
        width: 2.2rem;
      }
      span{
        font-size: .12rem;
        padding-right: .1rem;
      }
      em{
        font-size: .12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/BlockList/BlockList.vue